import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.early_repayment.choose_repayment_amount.title',
        defaultMessage: 'How much would you like to repay?'
    },
    subTitle: {
        id: '_.early_repayment.choose_repayment_amount.sub_title',
        defaultMessage: '-'
    },
    back: {
        id: '_.early_repayment.choose_repayment_amount.back',
        defaultMessage: '← Return home'
    },
    next: {
        id: '_.early_repayment.choose_repayment_amount.next',
        defaultMessage: 'Next step →'
    }
});
